import { render, staticRenderFns } from "./WiringsTable.vue?vue&type=template&id=47133de8"
import script from "./WiringsTable.vue?vue&type=script&lang=js"
export * from "./WiringsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports